import defaultAttributes from '../defaultAttributes';

const Thermometer = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M12 2a2 2 0 00-2 2v10.5a4 4 0 104 0V4a2 2 0 00-2-2z' }]],
];

export default Thermometer;
